export const auth = {
  authHomeTitle: 'Vítejte!',
  authHomeButtonBranded: 'Pokračovat s Email',
  authHomeButtonApple: 'Pokračovat s Apple',
  authHomeButtonGoogle: 'Pokračovat s Google',
  authHomeButtonFacebook: 'Pokračovat s Facebook',
  authHomeButtonLinkedin: 'Pokračovat s LinkedIn',
  authStartTitle: 'Zadejte E-mail',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Zadejte správný E-mail!',
  authStartInputPasswordError: 'Zadejte správné heslo!',
  authWhoops: 'Ach jo!',
  authStartConfirmButton: 'Pokračovat',
  authRegisteredTitle: 'Vítejte zpět!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Heslo',
  authRegisteredForgotPassword: 'Zapomněli jste heslo',
  authAlertIncorrectPassword: 'Vaše e-mailová adresa nebo heslo je nesprávné',
  authAlertRequiredPassword: 'Zadejte správné heslo',
  authFinishSignUpTitle: 'Dokončete registraci',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Jméno',
  authFinishSignUpLastNameInputTitle: 'Příjmení',
  authFinishSignUpPasswordInputTitle: 'Heslo',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Doporučujeme používat:</li><li class="list-disc">Minimálně 8 znaků</li><li class="list-disc">Alespoň 1 číslo</li><li class="list-disc">Alespoň 1 speciální znak</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Kliknutím na Registrovat souhlasíte s našimi',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    text2: 'a',
    termsOfUse: 'Podmínky použití'
  },
  authFinishSignUpConfirmButton: 'Registrovat',
  authFinishSignUpErrorFirstName: 'Jméno nesmí být prázdné!',
  authFinishSignUpErrorLastName: 'Příjmení nesmí být prázdné!',
  authFinishSignUpErrorPassword: 'Zvolili jste příliš krátké heslo!',
  authEmailConfirmationTitle: 'Zkontrolujte svůj e-mail',
  authEmailConfirmationContent:
    'Poslali jsme vám potvrzovací e-mail, abychom ověřili vaši e-mailovou adresu. Prosím, zkontrolujte také složku spam, pokud nemůžete najít e-mail ve své hlavní složce',
  authEmailConfirmationConfirmButton: 'Přejít na hlavní obrazovku',
  authAlertEmailConfirmation: 'Stále jste nepotvrdili svůj e-mail - zkontrolujte svou e-mailovou schránku!',
  authResetPasswordTitle: 'Zkontrolujte svůj e-mail',
  authResetPasswordDescription:
    'Poslali jsme vám odkaz na resetování hesla na váš e-mail. Prosím, zkontrolujte také složku spam, pokud nemůžete najít e-mail ve své hlavní složce',
  authResetPasswordButton: 'Na hlavní',
  authNewPasswordTitle: 'Zadejte nové heslo',
  authNewPasswordInputTitle: 'Nové heslo',
  authNewPasswordButton: 'Resetovat heslo',
  authNewPasswordAlertValidation: 'Vaše heslo je příliš snadné!',
  authPasswordChangeSuccessTitle: 'Heslo bylo změněno!',
  authPasswordChangeSuccessContent: 'Úspěšně jste změnili své heslo!',
  authPasswordChangeSuccessButton: 'Na hlavní',
  authPasswordChangeErrorTitle: 'Došlo k chybě!',
  authPasswordChangeErrorContent: 'Něco se pokazilo při pokusu o resetování hesla! Zkuste to prosím později.',
  authPasswordChangeErrorButton: 'Na hlavní',
  authInvitationTitle: 'Vyberte si heslo',
  authInvitationInputTitle: 'Heslo',
  authInvitationButton: 'Vybrat heslo',
  authEmailAddressConfirmed: 'Vaše e-mailová adresa byla potvrzena!'
}
